import React from 'react';
import { AddToEstimateButtonAndDialog } from 'components/AddToEstimate/AddToEstimateButtonAndDialog';
import { ReferencePriceSection } from 'components/ReferencePriceSection';
import TireBasketPriceInfo from 'components/TireBasketPriceInfo';
import { DATAHUB, TIRE } from 'domains/catalog/Catalog.types';
import { SparePartsViewType } from 'domains/user';
import { AvailabilityWrapper } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/Components/AvailabilityWrapper';
import { Box, Flex, MarginBox } from 'UI';

interface PriceLike {
  garageView?: {
    vatExcludedPrice?: number | string;
  };
}

interface PriceActionsBlockProps {
  compact?: boolean;
  isCatalog: boolean;
  isAvailableSoon: boolean;
  isNoLongerAvailable: boolean;
  price?: PriceLike | null;
  partNumber: string;
  sparePartsView: SparePartsViewType;
  clientDiscount?: number;
  tireSetParam?: number;
  onAddToCart: () => void;
  onAddToEstimate: (qty?: number) => void;
  dim: boolean;
}

export const PriceActionsBlock = ({
  compact,
  isCatalog,
  isAvailableSoon,
  isNoLongerAvailable,
  price,
  partNumber,
  sparePartsView,
  clientDiscount,
  tireSetParam,
  onAddToCart,
  onAddToEstimate,
  dim,
}: PriceActionsBlockProps) => {
  const canEstimate = !isAvailableSoon && !isNoLongerAvailable && !!price?.garageView?.vatExcludedPrice;

  return (
    <Flex direction="column" minWidth={400} justify="center" align={compact ? 'flex-start' : 'inherit'}>
      <Flex direction="row" justify="center" align="center">
        <AvailabilityWrapper dim={dim}>
          <ReferencePriceSection
            referenceNumber={partNumber}
            sparePartsView={sparePartsView}
            handleAddToCartClick={onAddToCart}
            vehicleKey={undefined}
            catalogSource={DATAHUB}
            referenceType={TIRE}
            align="left"
            narrow={compact}
            useCompactView={compact}
            isAvailableSoon={isAvailableSoon}
            isNoLongerAvailable={isNoLongerAvailable}
            clientDiscount={clientDiscount}
          />
        </AvailabilityWrapper>

        {canEstimate ? (
          <>
            <MarginBox ml={25} />
            <AddToEstimateButtonAndDialog
              handleAddToEstimateClick={onAddToEstimate}
              size={compact ? 'lg' : 'sm'}
              isVehicleCatalog={isCatalog}
              initCount={tireSetParam}
            />
          </>
        ) : (
          <Box width={40} />
        )}
      </Flex>

      <MarginBox {...(!compact && { ml: 18, mt: 5 })}>
        <TireBasketPriceInfo
          referenceNumber={partNumber}
          sparePartsView={sparePartsView}
          clientDiscount={clientDiscount}
        />
      </MarginBox>
    </Flex>
  );
};
